<template>
  <div class="container">
    <div class="row justify-content-center align-items-center mh-90vh">
      <div class="col-lg-5 col-md-8">
        <div class="card pl-2 text-white main-color mb-1">
          <div class="card-body h2">
            <span class="test-header-color" v-if="app_env !== 'production'">
              【テスト環境】
            </span>
            {{this.config.projectName}}
          </div>
        </div>
        <div class="card-group">
          <div class="card p-4">
            <b-overlay :show="overlayShow" rounded="sm">
              <div class="card-body">
                <h1>Login</h1>
                <div class="input-group mb-3 mt-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <b-icon icon="bag"></b-icon>
                    </span>
                  </div>
                  <input class="form-control" :class="{'is-invalid is-invalid-custom' : validation.hasError('projectNumber')}" type="text" placeholder="案件No" ref="projectNumber" v-model="projectNumber" autocomplete="off">
                  <div class="invalid-feedback">{{ validation.firstError('projectNumber') }}</div>
                </div>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <b-icon icon="lock"></b-icon>
                    </span>
                  </div>
                  <input class="form-control" :class="{'is-invalid is-invalid-custom' : validation.hasError('password')}" type="password" placeholder="パスワード" ref="password" v-model="password" autocomplete="off">
                  <div class="invalid-feedback">{{ validation.firstError('password') }}</div>
                </div>
                <div class="mb-3">
                  <div class="input-group" style="justify-content:space-evenly;" :class="{'is-invalid': validation.hasError('customerType')}">
                    <div>
                      <input type="radio" id="main" value="main" v-model="customerType" style="transform: scale(1.3);" />
                      <label for="main" class="mr-4 mb-0 font-weight-bold" style="font-size:1.3rem;">新郎・新婦</label>
                    </div>
                    <div>
                      <input type="radio" id="guest" value="guest" v-model="customerType" />
                      <label for="guest" class="mb-0 mt-1" style="font-size:1rem;">ご親族・ゲスト</label>
                    </div>
                  </div>
                  <div class="invalid-feedback">{{ validation.firstError('customerType') }}</div>
                  <div style="font-size:0.8rem;" class="mt-4">入室時はマイク・カメラはOFFとなっております。<br>ご準備が整いましたら、ONへの切替をお願いいたします。</div>
                </div>
                <div class="row mb-3">
                  <div class="col-12">
                    <b-button block variant="primary" @click.stop.prevent="login()">ログイン</b-button>
                  </div>
                </div>
              </div>
            </b-overlay>
          </div>
        </div>
      </div>
    </div>
    <CommonModal ref="commonModal" />
    <div class="p-2">
      <p class="mb-0 text-light h2" id="logo" style="cursor:default;user-select:none" v-if="tabErrorShow">
        <a href="javascript:void(0)" style="font-size: 11px; color:red" @click="clickTabIni">
          {{ this.consts.messages.clearMultipleStart }}
          <!--※他のタブで打合せ操作を行っていないのに、「複数のタブで打合せ操作を行うことはできない」旨のエラーが発生している場合-->
        </a>
        <CommonModal ref="commonModalForTabIni" @confirmOk="deleteTabInfo" />
      </p>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import CommonModal from '@/components/CommonModal'
import LoginModel from '@/models/LoginModel'
import MeetingStartModel from '@/models/MeetingStartModel'
import SimpleVueValidation from 'simple-vue-validator'
import cstore from '@/store/customer-store'
import mstore from '@/store/meeting-store'
import CommonLogModel from '@/models/CommonLogModel'
const Validator = SimpleVueValidation.Validator

Vue.use(SimpleVueValidation)

export default {
  name: 'CustomerLogin',
  components: {CommonModal},
  data () {
    return {
      overlayShow: false,
      password: '',
      projectNumber: '',
      customerType: '',
      app_env: process.env.APP_ENV,
      tabErrorShow: false
    }
  },
  validators: {
    password: function (value) {
      return Validator.value(value)
    },
    projectNumber: function (value) {
      return Validator.value(value).required(this.consts.validationMsg.login.projectNumber.required)
    },
    customerType: function (value) {
      return Validator.value(value).required(this.consts.validationMsg.login.customerType.required)
    }
  },
  methods: {
    login: async function () {
      try {
        // 複数タブで開こうとした場合
        console.log(localStorage.getItem('tabInfo'))
        if (localStorage.getItem('tabInfo')) {
          this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.multipleStart)
          this.tabErrorShow = true
          return false
        }
        let isError = await this.$validate()
          .then((success) => {
            return !success
          })

        if (isError) {
          return false
        }

        this.overlayShow = true

        // お客様情報を初期化
        if (cstore.getters.bothFamilyName1) cstore.commit('setBothFamilyName1', '')
        if (cstore.getters.bothFamilyName2) cstore.commit('setBothFamilyName2', '')
        if (cstore.getters.groomLastName) cstore.commit('setGroomLastName', '')
        if (cstore.getters.groomFirstName) cstore.commit('setGroomFirstName', '')
        if (cstore.getters.groomPhoneNumber) cstore.commit('setGroomPhoneNumber', '')
        if (cstore.getters.brideLastName) cstore.commit('setBrideLastName', '')
        if (cstore.getters.brideFirstName) cstore.commit('setBrideFirstName', '')
        if (cstore.getters.bridePhoneNumber) cstore.commit('setBridePhoneNumber', '')
        if (cstore.getters.mailAddress) cstore.commit('setMailAddress', '')
        if (cstore.getters.brideMailAddress) cstore.commit('setBrideMailAddress', '')
        if (cstore.getters.groomLastNameKana) cstore.commit('setGroomLastNameKana', '')
        if (cstore.getters.groomFirstNameKana) cstore.commit('setGroomFirstNameKana', '')
        if (cstore.getters.brideLastNameKana) cstore.commit('setBrideLastNameKana', '')
        if (cstore.getters.brideFirstNameKana) cstore.commit('setBrideFirstNameKana', '')

        // 一部セッション情報を初期化
        sessionStorage.removeItem('hideMySelfVideo')
        sessionStorage.removeItem('hideYourSelfVideo')
        sessionStorage.removeItem('hideGuest1SelfVideo')
        sessionStorage.removeItem('hideGuest2SelfVideo')
        sessionStorage.removeItem('hideGuest3SelfVideo')

        // 音声、ビデオ情報初期化
        if (mstore.getters.isMicrophoneMute) mstore.commit('setIsMicrophoneMute', true)
        if (mstore.getters.speakerVolume) mstore.commit('setSpeakerVolume', 0.5)
        if (mstore.getters.isCameraStop) mstore.commit('setIsCameraStop', true)
        if (mstore.getters.isVirtualBackgroundStop) mstore.commit('setIsVirtualBackgroundStop', false)

        const reqData = {
          projectNumber: this.$refs.projectNumber.value,
          password: this.$refs.password.value,
          afterMTG: '0',
          attendeeType: this.consts.attendeeType.customer
        }

        const loginModel = await LoginModel.apiSetStore(this.$bvModal, reqData, () => {
          this.overlayShow = false
        })

        localStorage.isOnlineMeeting = await loginModel.isOnlineMeeting
        // 対面(オンラインじゃない)時はアジェンダ画面に遷移
        const params = {'attendeeType': this.consts.attendeeType.customer, 'customerType': this.customerType}

        this.overlayShow = true
        const meetingStartModel = await MeetingStartModel.apiSetStore(this.$bvModal, params, () => {
          this.overlayShow = false
        })
        sessionStorage.meeting = await JSON.stringify(meetingStartModel.meeting)
        sessionStorage.attendee = await JSON.stringify(meetingStartModel.attendee)
        sessionStorage.customerType = this.customerType

        // DB上のアドレスへの画面遷移
        let targetPath = '/customer/meeting/agenda'
        let urlUpdatTime = Date.parse(meetingStartModel.meetingURL['updatedDateTime'] + '+09:00')
        // DBのデータが一定時間以内ならDBのURLに遷移する
        if (Date.now() - urlUpdatTime < this.config.UrlTransitionTimeLimit) {
          let meetingurl = meetingStartModel.meetingURL['currentURLPath']
          if (meetingurl !== '') {
            targetPath = '/customer/' + meetingurl
            if (meetingStartModel.meetingURL['operatingPrivilege'] === '1') {
              cstore.commit('setIsOperationPossible', true)
            } else {
              cstore.commit('setIsOperationPossible', false)
            }
            if (meetingStartModel.meetingURL['customerDisplayFlag'] === '1') {
              cstore.commit('setCustomerDisplayFlag', true)
            } else {
              cstore.commit('setCustomerDisplayFlag', false)
            }
          }

          const suggestionDataStr = meetingStartModel.meetingURL['suggestionData']
          if (suggestionDataStr) {
            const suggestionData = JSON.parse(suggestionDataStr)
            if ('suggestionType' in suggestionData) {
              localStorage.setItem('suggestionType', suggestionData['suggestionType'])
            }
          }
        }

        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'current_path': this.$route.path, 'reloadPath': targetPath}, () => {})
        this.$router.push(targetPath)
      } catch (err) {
        console.log(err)
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'errorMessage': err}, () => {})
      }
    },
    clickTabIni () {
      // ブラウザが正常終了せずローカルストレージが初期化されなかった時のための緊急処理
      this.$refs.commonModalForTabIni.msgBoxConfirm(this.consts.messages.confirmClear)
    },
    deleteTabInfo () {
      localStorage.removeItem('tabInfo')
    }
  },
  destroyed () {
    if (LoginModel.getStore()) {
      LoginModel.removeStore()
    }
  },
  mounted: function () {
    const loginStatus = {
      'afterMTG': '0',
      'prodInst': '0'
    }
    localStorage.setItem('loginStatus', JSON.stringify(loginStatus))
    if (process.env.APP_ENV !== 'production') {
      document.title = '【テスト環境】' + this.config.projectName
    }
  }
}
</script>
<style>
.mh-90vh {
  min-height: 90vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/CustomerLogin.vue